<template>
  <ThemeECommerceContainerSection category-event-name="" event-name="">
    <div class="tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row lg:tw-items-start lg:tw-gap-10">
      <div class="tw-w-full lg:tw-order-1 lg:tw-flex-1">
        <MediaImageLazyLoad
          :src="modelValue.content.image?.large || ''"
          :blank-src="modelValue.content.image?.tiny || ''"
          :alt="modelValue.content.title"
          aspect="343:257"
          custom-class="tw-h-auto tw-w-full tw-rounded-[5px] tw-object-cover"
          class="tw-w-full"
          seo-optimize
        />
      </div>
      <div class="tw-flex tw-w-full tw-flex-col tw-gap-5 lg:tw-order-2 lg:tw-w-[540px] lg:tw-shrink-0">
        <h1 class="tw-m-0 tw-text-mb-title-1 lg:tw-text-dt-title-1 lg:tw-text-left">
          {{ modelValue.content.title }}
        </h1>
        <DisplayHTMLContent
          class="tw-text-mb-body lg:tw-text-dt-body tw-text-dark-gray"
          :model-value="modelValue.content.description"
        />
        <div
          v-if="modelValue.content.showButton"
          class="tw-hidden lg:tw-block lg:tw-text-left"
        >
          <button
            v-if="modelValue.content.buttonType === 'youtube'"
            class="tw-rounded-[8px] tw-bg-primary tw-px-5 tw-py-3 tw-text-[16px] tw-leading-6 tw-text-white hover:tw-bg-primary/90"
            @click="
              showVideo(
                modelValue.content.buttonLink,
                modelValue.content.buttonName,
              )
            "
          >
            {{ modelValue.content.buttonName }}
          </button>
          <ExternalLink
            v-if="modelValue.content.buttonType === 'url'"
            class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-[8px] tw-bg-primary tw-px-5 tw-py-3 tw-text-[16px] tw-leading-6 tw-text-white hover:tw-bg-primary/90"
            :href="modelValue.content.buttonLink"
            title="introduce button"
            @click="
              eventHomeButton(
                modelValue.content.buttonLink,
                modelValue.content.buttonName,
              )
            "
          >
            {{ modelValue.content.buttonName }}
          </ExternalLink>
        </div>
        <MediaVideoModal
          v-if="
            modelValue.content.showButton &&
            modelValue.content.buttonType === 'youtube'
          "
          v-model="showVideoModal"
          :youtube-url="modelValue.content.buttonLink"
          container-class="tw-rounded-[8px]"
          close-button-class="tw-absolute -tw-top-12 tw-right-0 tw-z-30 tw-bg-transparent tw-text-white"
        />
      </div>
      <div
        v-if="modelValue.content.showButton"
        class="tw-flex tw-w-full tw-justify-center lg:tw-hidden"
      >
        <button
          v-if="modelValue.content.buttonType === 'youtube'"
          class="tw-rounded-[8px] tw-bg-primary tw-px-5 tw-py-3 tw-text-[16px] tw-leading-6 tw-text-white hover:tw-bg-primary/90"
          @click="
            showVideo(
              modelValue.content.buttonLink,
              modelValue.content.buttonName,
            )
          "
        >
          {{ modelValue.content.buttonName }}
        </button>
        <ExternalLink
          v-if="modelValue.content.buttonType === 'url'"
          class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-[8px] tw-bg-primary tw-px-5 tw-py-3 tw-text-[16px] tw-leading-6 tw-text-white hover:tw-bg-primary/90"
          :href="modelValue.content.buttonLink"
          title="introduce button"
          @click="
            eventHomeButton(
              modelValue.content.buttonLink,
              modelValue.content.buttonName,
            )
          "
        >
          {{ modelValue.content.buttonName }}
        </ExternalLink>
      </div>
    </div>
  </ThemeECommerceContainerSection>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: Object as PropType<HomeSection<Introduce>>,
    required: true,
  },
});
const { showVideoModal, showVideo, eventHomeButton } = useIntroduceSection();
</script>
